import { h, Component } from "preact";
import { Router, route } from "preact-router";
import { observer } from "mobx-preact";
import { observable, action, autorun, runInAction } from "mobx";
import LazyComponent from "./asyncComponent";
import { Link } from "preact-router";
//LANG
import { Text, IntlProvider } from "preact-i18n";
import lv from "./locals/lv.json";
import en from "./locals/en.json";
import ru from "./locals/ru.json";

import Header from "./header";
// import Showcase from './showcase'

// Code-splitting is automated for routes
import Home from "../routes/home";
import Internet from "../routes/internet";
import Startups from "../routes/startups";
import Services from "../routes/services";
import Faq from "../routes/faq";
import Emails from "../routes/services/email";
import Phone from "../routes/services/phone";
import Hosting from "../routes/services/hosting";
import PBX from "../routes/services/pbx";
import Surveillance from "../routes/services/surveillance";
import ISDN from "../routes/services/isdn";
import Files from "../routes/services/files";
import Serverless from "../routes/services/serverless";
import SIP from "../routes/services/sip";
import Fax from "../routes/services/fax";
import Equipment from "../routes/services/equipment";

import Content from "../routes/content";
import Contact from "../routes/contact";
import Availability from "../routes/availability";
import Support from "../routes/support";

// TODO - add api
// import Profile from '../routes/profile';

import ServicesHeader from "./header/servicesHeader";

import store from "../store";
import "../style";

const locales = {
  lv: lv,
  ru: ru,
  en: en
};

export default
@observer
class App extends Component {
  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
  state = { loading: false };

  headerSettings = {
    "/:lang/": undefined,
    "/:lang/internet": { title: "plans.title", particles: true, clipped: true },
    "/:lang/startups": { title: "startups.title", particles: true, clipped: 2 },
    "/:lang/support": { title: "support.title", img: "009.jpg" },
    "/:lang/email": { title: "email.title", img: "005.jpg" },
    "/:lang/faq": { title: "faq.title", img: "002.jpg" },
    "/:lang/:section": undefined,
    "/:lang/contact": { title: "contacts.title", img: "008.jpg" },
    "/:lang/availability": {
      extended: true,
      title: "availability.title",
      img: "007.jpg"
    },
    "/:lang/profile/": {
      title: "header.links.cabinet",
      particles: true,
      profile: true
    },
    "/:lang/terms": { title: "termsofuse", img: "010.jpg" },
    "/:lang/privacy": { title: "footer.menu.site.item5", img: "010.jpg" },
    "/:lang/company": { title: "footer.menu.about", img: "006.jpg" },
    "/:lang/notfound": { title: "notfound", img: "010.jpg" },

    "/:lang/services": { title: "services.title", img: "001.jpg" },
    "/:lang/telephone": { title: "phone.title", img: "010.jpg" },
    "/:lang/hosting": {
      title: "services.services.item3.title",
      img: "010.jpg"
    },
    "/:lang/pbx": { title: "services.services.item4.title", img: "010.jpg" },
    "/:lang/surveillance": {
      title: "services.services.item5.title",
      img: "010.jpg"
    },
    "/:lang/isdn": {
      title: "services.services.item6.title",
      title2: "services.services.item6.title2",
      img: "010.jpg"
    },
    "/:lang/files": {
      title: "services.services.item7.title",
      title2: "services.services.item7.title2",
      img: "010.jpg"
    },
    "/:lang/serverless-office": {
      title: "services.services.item8.title",
      title2: "services.services.item8.title2",
      img: "010.jpg"
    },
    "/:lang/sip": { title: "services.services.item9.title", img: "010.jpg" },
    "/:lang/fax": { title: "services.services.item10.title", img: "010.jpg" },
    "/:lang/equipment": {
      title: "services.services.item11.title",
      title2: "services.services.item11.title2",
      img: "009.jpg"
    }
  };

  handleRoute = e => {
    if (e.current.attributes.path.indexOf("/:lang") == 0) {
      store.setRedirect(e.current.attributes.path.split("/:lang")[1]);
    }
    if (e.url != this.prevPath) {
      if (e.current && e.current.attributes && e.current.attributes.path) {
        if (
          typeof window !== "undefined" &&
          window.ga &&
          typeof window.ga == "function"
        ) {
          let pageTitle = "DolphNet";
          if (this.headerSettings[e.current.attributes.path])
            pageTitle = this.headerSettings[e.current.attributes.path].title;
          // console.log(e);
          ga("send", { hitType: "pageview", page: e.url, title: pageTitle });
        }
        // Dont show loader or scroll to top when navigation is within the same component
        if (this.prevComponent != e.current.attributes.path) {
          this.prevComponent = e.current.attributes.path;
          this.setState({ loading: true });
          if (this.headerSettings[e.current.attributes.path]) {
            // console.log('setup header',this.headerSettings[e.current.attributes.path]);
            this.setState({
              headerInfo: this.headerSettings[e.current.attributes.path]
            });
          } else {
            this.setState({ headerInfo: undefined });
          }

          if (typeof window !== "undefined") window.scrollTo(0, 0);
        }
      }
      runInAction(() => {
        this.prevPath = e.url;
        store.hideMenu = e.url.includes("/profile");
        e.url == "/" ||
        (e &&
          e.current &&
          e.current.attributes &&
          !store.langs.includes(e.current.attributes.lang))
          ? route("/lv/")
          : null;
        if (
          e.current &&
          e.current.attributes &&
          e.current.attributes.matches.lang
        ) {
          var thisLang = e.current.attributes.matches.lang;
          if (store.lang != thisLang) {
            this.setState({ loading: false });
            store.setLang(thisLang);
            setTimeout(() => this.forceUpdate());
          }
        }
        store.activePage = e.url.substring(3);
        store.toggleMenu(true);
      });
    }
  };
  handleScroll = () => {
    if (typeof window !== "undefined")
      store.setSticky(
        window.matchMedia("(min-width: 992px)").matches &&
          window.pageYOffset > this.headerOffset
      );
  };

  loading = e => {
    setTimeout(() => this.setState({ loading: false }));
  };
  componentDidMount() {
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", this.handleScroll);

      store.loadGA();
    }
    let el = this.headerRef;
    if (el && el.offsetTop !== undefined && !this.headerOffset) {
      this.headerOffset = el.offsetTop + 250; //OLD VALUE = 30
    }
  }
  componentWillUnmount() {
    if (typeof window !== "undefined")
      window.removeEventListener("scroll", this.handleScroll);
  }
  constructor() {
    super();
  }
  render(props, state) {
    let prefix = "/" + store.lang;
    return (
      <div>
        <IntlProvider definition={locales[store.lang]}>
          <div>
            {!store.cookiebarDismissed && (
              <div id="privacy-policy-note">
                <div class="container wide">
                  <p>
                    <Text id="header.cookies.text" />
                    &nbsp;
                    <Link href={prefix + "/privacy"}>
                      <Text id="header.cookies.link" />
                    </Link>
                    .
                  </p>
                  <a class="close" onClick={() => store.dismissCookiebar()}>
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon">
                      <use xlinkhref="/assets/img/icons.svg#close"></use>
                    </svg>
                  </a>
                </div>
              </div>
            )}
            <Header mainRef={el => (this.headerRef = el)} />

            <ServicesHeader header={this.state.headerInfo} />
            <div
              style={
                (state.loading ? "min-height:100vh;" : "") +
                "position:relative;"
              }
            >
              <div
                class={"preloader-small" + (state.loading ? " loading" : "")}
              />
              <Router onChange={this.handleRoute}>
                <Home default path="/:lang/" loading={this.loading} />
                <Internet path="/:lang/internet" loading={this.loading} />
                <Startups path="/:lang/startups" loading={this.loading} />
                <Support path="/:lang/support" loading={this.loading} />
                <Services path="/:lang/services" loading={this.loading} />
                <Phone path="/:lang/telephone" loading={this.loading} />
                <Emails path="/:lang/email" loading={this.loading} />
                <Hosting path="/:lang/hosting" loading={this.loading} />
                <PBX path="/:lang/pbx" loading={this.loading} />
                <Surveillance
                  path="/:lang/surveillance"
                  loading={this.loading}
                />
                <ISDN path="/:lang/isdn" loading={this.loading} />
                <Files path="/:lang/files" loading={this.loading} />
                <Serverless
                  path="/:lang/serverless-office"
                  loading={this.loading}
                />
                <SIP path="/:lang/sip" loading={this.loading} />
                <Fax path="/:lang/fax" loading={this.loading} />
                <Equipment path="/:lang/equipment" loading={this.loading} />

                <Faq path="/:lang/faq" loading={this.loading} />
                <Content
                  path="/:lang/terms"
                  section="terms"
                  loading={this.loading}
                />
                <Content
                  path="/:lang/privacy"
                  section="privacy"
                  loading={this.loading}
                />
                <Content
                  path="/:lang/company"
                  section="company"
                  loading={this.loading}
                />
                <Content
                  path="/:lang/notfound"
                  section="notfound"
                  loading={this.loading}
                />
                <Content path="/:lang/:section" loading={this.loading} />
                <Contact path="/:lang/contact" loading={this.loading} />
                <Availability
                  path="/:lang/availability"
                  loading={this.loading}
                />

                {/* TODO: API
								<Profile path="/:lang/profile/" loading={this.loading}/>
							*/}
              </Router>
            </div>
            {/*<div class={"preloader-small_second"+(state.loading?' loading':"")}/>*/}

            <LazyComponent getComponent={() => import("./reviews")} />
            <LazyComponent
              getComponent={() => import("./footer")}
              prefix={prefix}
            />
            <LazyComponent getComponent={() => import("./loginmodal")} />
            <LazyComponent getComponent={() => import("./calcModal")} />
          </div>
        </IntlProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js